import styles from './aiIcon.module.less';

type AiIconProps = {
    className?: string;
    noSpace?: boolean;
    noSeparator?: boolean;
};

/**
 * Icon for ai features
 * @param param0
 * @returns
 */
export function AiIcon({ className = '', noSpace = false, noSeparator = false }: AiIconProps) {
    return (
        <div className={[styles.aiIcon, className, noSpace ? styles.noSpace : ''].join(' ')}>
            {!noSeparator && <div className={styles.aiSuffixSeparator} />}
            <span className={styles.aiSuffixText}>AI</span>
        </div>
    );
}
